var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 36.6667C70 55.1667 57.2 72.4667 40 76.6667C22.8 72.4667 10 55.1667 10 36.6667V16.6667L40 3.33334L70 16.6667V36.6667ZM40 70C52.5 66.6667 63.3333 51.8 63.3333 37.4V21L40 10.6L16.6667 21V37.4C16.6667 51.8 27.5 66.6667 40 70ZM49.3333 36.6667V31.6667C49.3333 27 44.6667 23.3333 40 23.3333C35.3333 23.3333 30.6667 27 30.6667 31.6667V36.6667C28.6667 36.6667 26.6667 38.6667 26.6667 40.6667V52.3333C26.6667 54.6667 28.6667 56.6667 30.6667 56.6667H49C51.3333 56.6667 53.3333 54.6667 53.3333 52.6667V41C53.3333 38.6667 51.3333 36.6667 49.3333 36.6667ZM45 36.6667H35V31.6667C35 29 37.3333 27.3333 40 27.3333C42.6667 27.3333 45 29 45 31.6667V36.6667Z",
    fill: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.a5d3075410cb8211251872f2ab065323.svg";
export { ForwardRef as ReactComponent };